import { render, staticRenderFns } from "./SupplierForm.vue?vue&type=template&id=44d782b0&"
import script from "./SupplierForm.vue?vue&type=script&lang=js&"
export * from "./SupplierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports